import React from "react";
import { Icon } from "@clarkinc/zest-design-system/ui";

import { cls } from "@wss/cls";
import { TopperSection } from "../../types";

import Title from "../../components/Title";
import Section from "../../components/Section";
import Carousel from "../../components/Carousel";

import { getTopperVariant } from "../utility";

interface MultiSelectProps {
  sections: TopperSection[];
  previousLink: string;
  previousSectionName: string;
}

const MultiSelect = ({
  sections,
  previousLink,
  previousSectionName,
}: MultiSelectProps) => {
  const { name, items, displayType } = sections[0]!;

  const TopperVariant = getTopperVariant(displayType);
  const topperItems = items.map((item, index) => (
    <>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <TopperVariant
        itemId={index}
        itemIndex={index}
        key={`topperVariant-${index}`}
        {...item}
      />
    </>
  ));

  return (
    <nav aria-label="Sub-Categories">
      <div
        className={cls(
          "flex flex-col p-4 bg-white border-x border-b border-t-0 border-solid border-gray-200 gap-4",
          "sm:gap-0",
          "md:flex-row md:pl-6 md:pr-12 md:py-6",
        )}
      >
        <Title
          className={cls(
            "flex items-center justify-start mb-0 flex-shrink-0",
            "sm:mb-4",
            "md:mb-0 md:justify-center md:flex-col md:w-full md:max-w-[192px]",
            "lg:max-w-[205px]",
            "xl:max-w-[198px]",
            "xxxl:max-w-[192px]",
            "xxxxl:max-w-[235px]",
          )}
        >
          <Title.Header
            id="multi-select-topper"
            className="text-lg leading-5 text-gray-800 font-semibold text-center mb-0"
          >
            {name}
            <span className="hidden md:inline">:</span>
          </Title.Header>
          {previousSectionName ? (
            <a
              href={previousLink}
              className={cls(
                "flex items-center group ml-4 text-xs underline font-normal text-gray-800",
                "hover:text-green-700 active:text-green-800",
                "md:ml-0 md:mt-2",
              )}
              data-testid="topper_back_link"
            >
              <Icon
                name="ri-arrow-left-s-line"
                size="2xsmall"
                className={cls(
                  "align-sub mr-1",
                  "group-hover:fill-green-700 group-active:fill-green-800",
                  "md:inline",
                )}
                theme="wss"
              />
              Back to {previousSectionName}
            </a>
          ) : null}
        </Title>
        <Section
          className={cls(
            "relative pt-0",
            "md:ml-12 md:w-[calc(100%-257px)]",
            "lg:w-[calc(100%-270px)]",
            "xl:w-[calc(100%-263px)]",
            "xxxl:w-[calc(100%-257px)]",
            "xxxxl:w-[calc(100%-300px)]",
          )}
        >
          {/* To be replaced with a zest carousel */}
          <Carousel isMultiSelect topperItems={topperItems} />
        </Section>
      </div>
    </nav>
  );
};

export default MultiSelect;
